// Conservation locale du dernier tableau de bord et de la session, pour consultation hors ligne.
const PREF = "dash:";
const MAX = 2;
const SESSION_KEY = "me_hors_ligne";
export const JOURS_SESSION = 7;

const cles = () => Object.keys(localStorage).filter((k) => k.startsWith(PREF));

export const estErreurReseau = (e) => !e?.response || e.code === "ERR_NETWORK" || e.message === "Network Error";

export function enregistrerDashboard(cle, analyse) {
  try {
    const leger = { ...analyse, issues_sample: (analyse.issues_sample || []).slice(0, 40) };
    const anciennes = cles().filter((k) => k !== PREF + cle)
      .map((k) => [k, JSON.parse(localStorage.getItem(k) || "{}").le || ""])
      .sort((a, b) => (a[1] < b[1] ? -1 : 1));
    while (anciennes.length >= MAX) localStorage.removeItem(anciennes.shift()[0]);
    localStorage.setItem(PREF + cle, JSON.stringify({ le: new Date().toISOString(), analyse: leger }));
  } catch { cles().forEach((k) => localStorage.removeItem(k)); }
}

export function lireDashboard(cle) {
  try {
    const b = localStorage.getItem(PREF + cle);
    return b ? JSON.parse(b) : null;
  } catch { return null; }
}

const CARTE = "carte:";

export function enregistrerCarte(cle, data) {
  try {
    Object.keys(localStorage).filter((k) => k.startsWith(CARTE) && k !== CARTE + cle).forEach((k) => localStorage.removeItem(k));
    localStorage.setItem(CARTE + cle, JSON.stringify({ le: new Date().toISOString(), data }));
  } catch { /* quota */ }
}

export function lireCarte(cle) {
  try {
    const b = localStorage.getItem(CARTE + cle);
    return b ? JSON.parse(b) : null;
  } catch { return null; }
}

const LISTE = "liste:dernier";
const QC = "qc:";

export function enregistrerListe(data) {
  try {
    localStorage.setItem(LISTE, JSON.stringify({ le: new Date().toISOString(), data: { ...data, items: (data.items || []).slice(0, 500) } }));
  } catch { localStorage.removeItem(LISTE); }
}

export function lireListe() {
  try {
    const b = localStorage.getItem(LISTE);
    return b ? JSON.parse(b) : null;
  } catch { return null; }
}

export function enregistrerQc(cle, data) {
  try {
    Object.keys(localStorage).filter((k) => k.startsWith(QC) && k !== QC + cle).forEach((k) => localStorage.removeItem(k));
    localStorage.setItem(QC + cle, JSON.stringify({ le: new Date().toISOString(), data: { ...data, issues: (data.issues || []).slice(0, 400) } }));
  } catch { Object.keys(localStorage).filter((k) => k.startsWith(QC)).forEach((k) => localStorage.removeItem(k)); }
}

export function lireQc(cle) {
  try {
    const b = localStorage.getItem(QC + cle);
    return b ? JSON.parse(b) : null;
  } catch { return null; }
}

export function enregistrerContexte(user, imports, schema) {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify({ le: new Date().toISOString(), user, imports, schema }));
  } catch { /* quota */ }
}

export function lireContexte() {
  try {
    const d = JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
    if (!d) return null;
    const age = (Date.now() - new Date(d.le).getTime()) / 86400000;
    return age <= JOURS_SESSION ? d : null;
  } catch { return null; }
}

export const oublierContexte = () => {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(LISTE);
  cles().forEach((k) => localStorage.removeItem(k));
  Object.keys(localStorage).filter((k) => k.startsWith(CARTE) || k.startsWith(QC)).forEach((k) => localStorage.removeItem(k));
};
